import createEnum from 'lib/createEnum';

export const ALIGNMENTS = createEnum('LEFT', 'RIGHT');
export const BORDER_RADII = createEnum('NONE', 'SMALL', 'LARGE');
export const CLOSE_ICON_TYPE = createEnum('DASH_ICON', 'X_ICON');
export const DISPLAY_TYPE = createEnum('ALL_PAGES', 'RULES_ONLY', 'DISABLED');
export const INITIAL_BUTTON_TYPES = createEnum('TEXT', 'ICON');
export const RULE_TYPES = createEnum('EXACT', 'CONTAINS', 'REGEX');
export const WIDGET_TYPES = createEnum('CHAT', 'SELF_SERVICE');

// camelCase because these are used as keys in the configuration
export const ICON_TYPES = {
  ATTACHMENT_CLOSE: 'attachmentClose',
  ATTACHMENT_UPLOAD: 'attachmentUpload',
  CHAT: 'chat',
  EXTERNAL_LINK: 'externalLink',
  INTERNAL_LINK: 'internalLink',
  SEARCH: 'search',
};

export default {
  ALIGNMENTS,
  BORDER_RADII,
  CLOSE_ICON_TYPE,
  DISPLAY_TYPE,
  INITIAL_BUTTON_TYPES,
  RULE_TYPES,
  WIDGET_TYPES,
  ICON_TYPES,
};
